
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CheckCircle2, AlertCircle } from "lucide-react";

interface EmailVerificationScreenProps {
  onBackToLogin: () => void;
}

const EmailVerificationScreen = ({ onBackToLogin }: EmailVerificationScreenProps) => {
  return (
    <div className="min-h-screen bg-tokscript-bg flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="bg-tokscript-card border-gray-800">
          <CardHeader>
            <div className="flex justify-center mb-4">
              <CheckCircle2 className="h-12 w-12 text-green-500" />
            </div>
            <CardTitle className="text-2xl text-center">Verify Your Email</CardTitle>
            <CardDescription className="text-center">
              We've sent a verification email to your inbox. Please check your email and click the verification link.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <Alert className="bg-blue-900/30 border-blue-700 text-blue-100">
              <AlertCircle className="h-5 w-5" />
              <AlertTitle>Important</AlertTitle>
              <AlertDescription>
                You need to verify your email before you can log in. Check your inbox and spam folder.
              </AlertDescription>
            </Alert>
            <div className="text-center text-sm text-gray-400">
              Once verified, you can return to the login page.
            </div>
          </CardContent>
          <CardFooter className="flex flex-col space-y-4">
            <Button 
              className="w-full bg-tokscript-cta hover:bg-tokscript-cta/90 text-black"
              onClick={onBackToLogin}
            >
              Return to login
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

export default EmailVerificationScreen;
